import AdminLayout from "../../modules/admin/page/Admin";
//
// Layouts
import AdminDashboard from "../../modules/admin/layouts/dashboard/AdminDashboard";
// Courses
import AdminCourses from "../../modules/admin/layouts/courses/AdminCourses";
import AdminCoursesCreation from "../../modules/admin/layouts/courses/AdminCoursesCreation";
import AdminCourseReading from "../../modules/admin/layouts/courses/AdminCourseReading";
import AdminCourseChaptersCreation from "../../modules/admin/layouts/courses/AdminCourseChaptersCreation";
import AdminCourseChapterLessonsCreation from "../../modules/admin/layouts/courses/AdminCourseChapterLessonsCreation";
// Challenges
import ChallengeContainer from "../../modules/challenge/layouts/ChallengeContainer";
import ChallengeContent from "../../modules/challenge/layouts/ChallengeContent";
//
import ChallengeThemeContainer from "../../modules/challenge/layouts/challenge-themes/ChallengeThemeContainer";
import ChallengeThemeCategory from "../../modules/challenge/layouts/challenge-themes/ChallengeThemeCategory";
import ChallengeThemeCategoryCreation from "../../modules/challenge/layouts/challenge-themes/ChallengeThemeCategoryCreation";
import ChallengeTheme from "../../modules/challenge/layouts/challenge-themes/ChallengeTheme";
import ChallengeThemeCreation from "../../modules/challenge/layouts/challenge-themes/ChallengeThemeCreation";
import ChallengeThemeQuestions from "../../modules/challenge/layouts/challenge-themes/ChallengeThemeQuestions";
import ChallengeThemeQuestionsCreation from "../../modules/challenge/layouts/challenge-themes/ChallengeThemeQuestionsCreation";
// Discussion
import Discussion from "../../modules/discussion/layout/Discussion";
import NotificationContainer from "../../modules/discussion/components/notification-container/NotificationContainer";
import DiscussionContainer from "../../modules/discussion/components/discussion-container/DiscussionContainer";
//
import SchoolContainer from "../../modules/admin/layouts/schools/SchoolContainer";
import School from "../../modules/admin/layouts/schools/School";
import SchoolCreation from "../../modules/admin/layouts/schools/SchoolCreation";
import SchoolStreams from "../../modules/admin/layouts/schools/SchoolStreams";
import SchoolStreamsCreation from "../../modules/admin/layouts/schools/SchoolStreamsCreation";
//
import UserContainer from "../../modules/admin/layouts/users/UserContainer";
import Users from "../../modules/admin/layouts/users/Users";
import UserCreation from "../../modules/admin/layouts/users/UserCreation";
import UserUpdate from "../../modules/admin/layouts/users/UserUpdate";
import UserDetails from "../../modules/admin/layouts/users/UserDetails";
import Overview from "../../modules/admin/components/overview/Overview";
import Documents from "../../modules/admin/components/documents/Documents";
//
import Settings from "../../modules/setting/Settings";

export const adminRoutes = [
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { path: "", element: <AdminDashboard /> },
      {
        path: "challenges",
        element: <ChallengeContainer />,
        children: [{ path: "", element: <ChallengeContent /> }],
      },
      {
        path: "challenge/themes",
        element: <ChallengeThemeContainer />,
        children: [
          { path: "", element: <ChallengeThemeCategory /> },
          {
            path: "categories/create",
            element: <ChallengeThemeCategoryCreation />,
          },
          {
            path: "get/:category_en/:category_fr",
            element: <ChallengeTheme />,
          },
          {
            path: ":category_en/:category_fr/create",
            element: <ChallengeThemeCreation />,
          },
          {
            path: ":id/:title_en/:title_fr/questions",
            element: <ChallengeThemeQuestions />,
          },
          {
            path: ":id/:title_en/:title_fr/questions/create",
            element: <ChallengeThemeQuestionsCreation />,
          },
        ],
      },
      {
        path: "discussions",
        element: <Discussion />,
        children: [
          { path: "", element: <NotificationContainer /> },
          { path: "messages", element: <DiscussionContainer /> },
        ],
      },
      {
        path: "schools",
        element: <SchoolContainer />,
        children: [
          { path: "", element: <School /> },
          { path: "create", element: <SchoolCreation /> },
          { path: ":title/:id/streams", element: <SchoolStreams /> },
          {
            path: ":title/:id/streams/create",
            element: <SchoolStreamsCreation />,
          },
          {
            path: ":title/:id/streams/:st_title/:st_id/courses",
            element: <AdminCourses />,
          },
          {
            path: ":title/:id/streams/:st_title/:st_id/courses/create",
            element: <AdminCoursesCreation />,
          },
          {
            path: "streams/courses/:course_id/reading",
            element: <AdminCourseReading />,
          },
          {
            path: "streams/courses/:course_id/chapters/create",
            element: <AdminCourseChaptersCreation />,
          },
          {
            path: "streams/courses/chapters/:chapter_id/lessons/create",
            element: <AdminCourseChapterLessonsCreation />,
          },
        ],
      },
      {
        path: "users",
        element: <UserContainer />,
        children: [
          { path: "", element: <Users /> },
          { path: "create", element: <UserCreation /> },
          { path: "update", element: <UserUpdate /> },
          {
            path: "details",
            element: <UserDetails />,
            children: [
              { path: "", element: <Overview /> },
              {
                path: "documents",
                element: <Documents />,
              },
            ],
          },
        ],
      },
      { path: "settings", element: <Settings /> },
    ],
  },
];
